/**
 * @generated SignedSource<<1f176c542efaa3532487bee8d97aa848>>
 * @relayHash 8a52802e7d25ffd13db00e8c40b36770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bce69cd28b17a3934cf6dc96c5385e26105c4b15a60442020391949fe051d3ce

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CompassLinkType = "CHAT_CHANNEL" | "DASHBOARD" | "DOCUMENT" | "ON_CALL" | "OTHER_LINK" | "PROJECT" | "REPOSITORY" | "%future added value";
export type CompassQuerySortOrder = "ASC" | "DESC" | "%future added value";
export type CompassSearchComponentQuery = {
  after?: string | null | undefined;
  fieldFilters?: ReadonlyArray<CompassQueryFieldFilter | null | undefined> | null | undefined;
  first?: number | null | undefined;
  query?: string | null | undefined;
  sort?: ReadonlyArray<CompassQuerySort | null | undefined> | null | undefined;
};
export type CompassQueryFieldFilter = {
  filter?: CompassQueryFilter | null | undefined;
  name: string;
};
export type CompassQueryFilter = {
  eq?: string | null | undefined;
  gt?: string | null | undefined;
  gte?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  lt?: string | null | undefined;
  lte?: string | null | undefined;
  neq?: string | null | undefined;
};
export type CompassQuerySort = {
  name?: string | null | undefined;
  order?: CompassQuerySortOrder | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery$variables = {
  cloudId: string;
  includeState: boolean;
  query?: CompassSearchComponentQuery | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery$data = {
  readonly compass: {
    readonly searchComponents: {
      readonly __typename: "CompassSearchComponentConnection";
      readonly nodes: ReadonlyArray<{
        readonly __typename: "CompassSearchComponentResult";
        readonly component: {
          readonly __typename: "CompassComponent";
          readonly description: string | null | undefined;
          readonly id: string;
          readonly inwardRelationships: {
            readonly __typename: "CompassRelationshipConnection";
            readonly nodes: ReadonlyArray<{
              readonly startNode: {
                readonly id: string;
                readonly name: string;
                readonly ownerId: string | null | undefined;
                readonly typeId: string;
              } | null | undefined;
            }> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            };
          } | {
            readonly __typename: "QueryError";
            readonly extensions: ReadonlyArray<{
              readonly __typename: string;
              readonly errorType: string | null | undefined;
              readonly statusCode: number | null | undefined;
            }> | null | undefined;
            readonly message: string | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly links: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null | undefined;
            readonly type: CompassLinkType;
            readonly url: AGG$URL;
          }> | null | undefined;
          readonly name: string;
          readonly outwardRelationships: {
            readonly __typename: "CompassRelationshipConnection";
            readonly nodes: ReadonlyArray<{
              readonly endNode: {
                readonly id: string;
                readonly name: string;
                readonly ownerId: string | null | undefined;
                readonly typeId: string;
              } | null | undefined;
            }> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            };
          } | {
            readonly __typename: "QueryError";
            readonly extensions: ReadonlyArray<{
              readonly __typename: string;
              readonly errorType: string | null | undefined;
              readonly statusCode: number | null | undefined;
            }> | null | undefined;
            readonly message: string | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly ownerId: string | null | undefined;
          readonly scorecardScores: ReadonlyArray<{
            readonly maxTotalScore: number;
            readonly totalScore: number;
          }> | null | undefined;
          readonly state?: string | null | undefined;
          readonly typeId: string;
        } | null | undefined;
        readonly link: AGG$URL;
      }> | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly __typename: string;
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery = {
  response: gqlJiraJswComponentsTableComponentsQuery$data;
  variables: gqlJiraJswComponentsTableComponentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeState"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "typeId"
},
v7 = {
  "kind": "ScalarField",
  "name": "ownerId"
},
v8 = {
  "types": [
    "DEPENDS_ON"
  ]
},
v9 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    },
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ]
    }
  ],
  "type": "QueryError"
},
v12 = [
  {
    "concreteType": "CompassCatalogQueryApi",
    "kind": "LinkedField",
    "name": "compass",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          }
        ],
        "kind": "LinkedField",
        "name": "searchComponents",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "CompassSearchComponentResult",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  },
                  {
                    "concreteType": "CompassComponent",
                    "kind": "LinkedField",
                    "name": "component",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "condition": "includeState",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "state"
                          }
                        ]
                      },
                      {
                        "concreteType": "CompassLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "concreteType": "CompassScorecardScore",
                        "kind": "LinkedField",
                        "name": "scorecardScores",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalScore"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "maxTotalScore"
                          }
                        ]
                      },
                      {
                        "alias": "inwardRelationships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "query",
                            "value": {
                              "direction": "INWARD",
                              "filters": (v8/*: any*/),
                              "first": 5
                            }
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "CompassRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CompassComponent",
                                    "kind": "LinkedField",
                                    "name": "startNode",
                                    "plural": false,
                                    "selections": (v9/*: any*/)
                                  }
                                ]
                              },
                              (v10/*: any*/)
                            ],
                            "type": "CompassRelationshipConnection"
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": "relationships(query:{\"direction\":\"INWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                      },
                      {
                        "alias": "outwardRelationships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "query",
                            "value": {
                              "direction": "OUTWARD",
                              "filters": (v8/*: any*/),
                              "first": 5
                            }
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "CompassRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CompassComponent",
                                    "kind": "LinkedField",
                                    "name": "endNode",
                                    "plural": false,
                                    "selections": (v9/*: any*/)
                                  }
                                ]
                              },
                              (v10/*: any*/)
                            ],
                            "type": "CompassRelationshipConnection"
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": "relationships(query:{\"direction\":\"OUTWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CompassSearchComponentConnection"
          },
          (v11/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "selections": (v12/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "selections": (v12/*: any*/)
  },
  "params": {
    "id": "bce69cd28b17a3934cf6dc96c5385e26105c4b15a60442020391949fe051d3ce",
    "metadata": {},
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4ab9e1653a1035fe1a30894f55185eb";

export default node;
